<mat-dialog-actions class="justify-content-between">

  <h4 class="f-s-16 f-w-600 m-b-16">{{ 'ENTITY.DAY_REPORT' | translate }}
  </h4>
  <button mat-icon-button class="d-flex justify-content-center" (click)="close()">
    <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
  </button>
</mat-dialog-actions>
<mat-divider></mat-divider>

<mat-dialog-content>

  <div class="readonly-note" *ngIf="readOnly">
    {{ 'LABEL.DISCHARGED_READONLY' | translate }}
  </div>

  <div class="daily-report-list-toolbar">
    <h4 class="m-0"></h4>
    <button type="button" mat-flat-button color="primary" *ngIf="canEdit" (click)="addReport()">
      <mat-icon>add</mat-icon>
      {{ 'BUTTON.BTN_ADD_REPORT' | translate }}
    </button>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

  <div class="daily-report-table-wrap" *ngIf="hasReports; else emptyState">
    <table mat-table [dataSource]="reports" class="w-100 daily-report-table">
      <ng-container matColumnDef="reportDate">
        <th mat-header-cell *matHeaderCellDef class="report-date-column">{{ 'LABEL.REPORT_DATE' | translate }}</th>
        <td mat-cell *matCellDef="let report" class="report-date-column">{{ report.reportDate | commonDate }}</td>
      </ng-container>

      <ng-container matColumnDef="reportTime">
        <th mat-header-cell *matHeaderCellDef class="report-time-column">{{ 'LABEL.REPORT_TIME' | translate }}</th>
        <td mat-cell *matCellDef="let report" class="report-time-column">{{ report.reportTime ? (report.reportTime | timeFormat) : '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef class="report-summary-column">{{ 'LABEL.DESCRIPTION' | translate }}</th>
        <td mat-cell *matCellDef="let report" class="report-summary-column">
          <span class="report-summary" [matTooltip]="getSummary(report)">{{ getSummary(report) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="medicines">
        <th mat-header-cell *matHeaderCellDef class="report-medicines-column">{{ 'LABEL.MEDICINE_ORDERS' | translate }}</th>
        <td mat-cell *matCellDef="let report" class="report-medicines-column">{{ report.medicines.length }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-right report-actions-column">{{ 'LABEL.ACTION_LABEL' | translate }}</th>
        <td mat-cell *matCellDef="let report" class="text-right report-actions-column">
          <button mat-icon-button color="primary" *ngIf="canViewReport" (click)="viewReport(report)"
            [matTooltip]="'LABEL.VIEW_LABEL' | translate">
            <i-tabler name="eye" class="icon-20 d-flex"></i-tabler>
          </button>
          <button mat-icon-button color="primary" *ngIf="canEdit" (click)="editReport(report)"
            [matTooltip]="'LABEL.EDIT' | translate">
            <i-tabler name="edit" class="icon-20 d-flex"></i-tabler>
          </button>
          <button mat-icon-button color="warn" *ngIf="canEdit" (click)="deleteReport(report)"
            [matTooltip]="'BUTTON.BTN_DELETE' | translate">
            <i-tabler name="trash" class="icon-20 d-flex"></i-tabler>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <ng-template #emptyState>
    <div class="empty-state" *ngIf="!isLoading">
      <i-tabler name="notes" class="icon-36 text-muted"></i-tabler>
      <h4>{{ 'LABEL.NO_DATA' | translate }}</h4>
      <p>{{ 'LABEL.EMPTY_DAILY_REPORT' | translate }}</p>
    </div>
  </ng-template>
</mat-dialog-content>
